import React from 'react';
import { Tooltip, OverlayTrigger } from "react-bootstrap";

const ItemCategory = ({ title, children }) => {
  return (
    <div className=''>
        <h5 className="text-black fs-5">
            <OverlayTrigger
                trigger="hover" 
                placement="bottom"
                overlay={
                    <Tooltip className="toltip-popover">
                        <span className="fs-8 text-white fw-semibold">Item Category</span>
                    </Tooltip>
                }
            >
                 <span>{title}</span>
            </OverlayTrigger>
        </h5>
      {children}
    </div>
  );
};

export default ItemCategory;
